import { turboproApi } from '@/api/turbopro';
import { getRelatoriosHeaders } from './shared';

export type StatusRobo = 'Ativo' | 'Inativo';

export interface BuscarStatusRoboResponse {
  NomeRobo: string;
  StatusRobo: StatusRobo;
}

export async function buscarStatusRoboApi(): Promise<BuscarStatusRoboResponse> {
  const resposta = await turboproApi<BuscarStatusRoboResponse>('Relatorios/BuscarStatusRobo', {
    headers: getRelatoriosHeaders(),
  });
  return resposta.data;
}
